var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "20 10 60 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.43 10c14.263 0 29.42 3.77 29.42 10.742v12.886l-.008 38.244v7.386c0 6.98-15.158 10.742-29.42 10.742C36.157 90 21 86.23 21 79.258V20.742C21 13.762 36.158 10 50.43 10zm26.648 54.4c-2.29 3.546-16.734 6.129-26.84 6.129-10.699 0-21.914-2.118-26.838-6.129v14.891c0 3.865 11.018 8.16 26.839 8.16 15.812 0 26.839-4.295 26.839-8.16zm0-20.149c-2.29 3.693-16.734 6.381-26.84 6.381-10.699 0-21.914-2.204-26.838-6.38v15.504c0 4.023 11.018 8.495 26.839 8.495 15.812 0 26.839-4.472 26.839-8.495zm0-19.051c-2.29 3.546-16.734 6.129-26.84 6.129-10.699 0-21.914-2.118-26.838-6.129v14.891c0 3.865 11.018 8.16 26.839 8.16 15.812 0 26.839-4.295 26.839-8.16zM50.43 12.582c-15.821 0-26.848 4.296-26.84 8.16 0 3.865 11.019 8.16 26.84 8.16 15.812 0 26.839-4.303 26.839-8.16 0-3.864-11.018-8.16-26.84-8.16z",
    fill: "#212121",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageSpace);
export default __webpack_public_path__ + "static/media/storage-space.37f1a35d7c76da4b09f288f8918314b1.svg";
export { ForwardRef as ReactComponent };